module.exports = __webpack_public_path__ + "img/arrow-left.7684e35b.svg";